var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagLinearGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20.5V3.72034",
    stroke: "#5E5E5E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.59622C4.5 3.59622 6.3612 3.35348 8.59895 3.79196C10.8367 4.23044 11.8353 5.29228 13.2313 5.92945C14.6274 6.56663 15.2383 6.55093 16.7762 6.47756C18.3462 6.40264 20.5 5.35262 20.5 5.35262L16.924 11.2871L20.5 15.5549",
    stroke: "url(#paint0_linear_1298_19604)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.59622C4.5 3.59622 6.3612 3.35348 8.59895 3.79196C10.8367 4.23044 11.8353 5.29228 13.2313 5.92945C14.6274 6.56663 15.2383 6.55093 16.7762 6.47756C18.3462 6.40264 20.5 5.35262 20.5 5.35262L16.924 11.2871L20.5 15.5549C20.5 16.2139 15.7697 17.8744 13.2313 16.4511C10.6929 15.0278 10.4218 14.6286 8.59895 14.2898C6.77613 13.951 5.22664 13.9998 4.5 13.9998L4.5 3.59622Z",
    stroke: "url(#paint1_linear_1298_19604)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1298_19604",
    x1: 30.6782,
    y1: 27.8907,
    x2: 27.4547,
    y2: 8.17012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1298_19604",
    x1: 30.6782,
    y1: 27.8907,
    x2: 27.4547,
    y2: 8.17012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagLinearGray);
export default __webpack_public_path__ + "static/media/flag-linear-gray.b01254706f6f2560dcabdffe2efe156a.svg";
export { ForwardRef as ReactComponent };